import { pick } from "lodash";

export const HEAD_OVERLAY = {
  blemishes: { id: 0, localization: "Пятна", min: 0, max: 23, default: 255 },
  facialHair: {
    id: 1,
    localization: "Лицевая растительность",
    min: 0,
    max: 28,
    default: 255,
  },
  eyebrows: { id: 2, localization: "Брови", min: 0, max: 33, default: 255 },
  ageing: { id: 3, localization: "Старение", min: 0, max: 14, default: 255 },
  makeup: { id: 4, localization: "Макияж", min: 0, max: 74, default: 255 },
  blush: { id: 5, localization: "Румянец", min: 0, max: 32, default: 255 },
  complexion: {
    id: 6,
    localization: "Цвет лица",
    min: 0,
    max: 11,
    default: 255,
  },
  sunDamage: {
    id: 7,
    localization: "Повреждения от солнца",
    min: 0,
    max: 10,
    default: 255,
  },
  lipstick: { id: 8, key: "lipstick", localization: "Помада", min: 0, max: 9, default: 255 },
  molesFreckles: {
    id: 9,
    localization: "Родинки/Веснушки",
    min: 0,
    max: 17,
    default: 255,
  },
  chestHair: {
    id: 10,
    localization: "Грудные волосы",
    min: 0,
    max: 16,
    default: 255,
  },
  bodyBlemishes: {
    id: 11,
    localization: "Недостатки на теле",
    min: 0,
    max: 11,
    default: 255,
  },
  addBodyBlemishes: {
    id: 12,
    localization: "Добавить недостатки на теле",
    min: 0,
    max: 1,
    default: 255,
  },
};

export const HAIR_STYLE = pick(HEAD_OVERLAY, ["facialHair", "eyebrows", "chestHair"]);

export const SKIN = pick(HEAD_OVERLAY, [
  "blemishes",
  "bodyBlemishes",
  "ageing",
  "molesFreckles",
  "makeup",
  "sunDamage",
]);

export const HEAD_OVERLAY_KEYS = Object.keys(HEAD_OVERLAY);
export const HAIR_STYLE_KEYS = Object.keys(HAIR_STYLE);
export const SKIN_KEYS = Object.keys(SKIN);

export const MAKEUP_OVERLAY_COLORS = [
  "#992532",
  "#c8395d",
  "#bd516c",
  "#b8637a",
  "#a6526b",
  "#b1434c",
  "#7f3133",
  "#a4645d",
  "#c18779",
  "#cba096",
  "#c6918f",
  "#ab6f63",
  "#b06050",
  "#a84c33",
  "#b47178",
  "#ca7f92",
  "#ed9cbe",
  "#e775a4",
  "#de3e81",
  "#b34c6e",
  "#712739",
  "#4f1f2a",
  "#aa222f",
  "#de2034",
  "#cf0813",
  "#e55470",
  "#dc3fb5",
  "#c227b2",
  "#a01ca9",
  "#6e1875",
  "#731465",
  "#56165c",
  "#6d1a9d",
  "#1b3771",
  "#1d4ea7",
  "#1e74bb",
  "#21a3ce",
  "#25c2d2",
  "#23cca5",
  "#27c07d",
  "#1b9c32",
  "#148604",
  "#70d041",
  "#c5ea34",
  "#e1e32f",
  "#ffdd26",
  "#fac026",
  "#f78a27",
  "#fe5910",
  "#be6e19",
  "#f7c97f",
  "#fbe5c0",
  "#f5f5f5",
  "#b3b4b3",
  "#919191",
  "#564e4e",
  "#180e0e",
  "#58969e",
  "#4d6f8c",
  "#1a2b55",
  "#a07e6b",
  "#826355",
  "#6d5346",
  "#3e2d27",
];

export const HAIR_COLORS: string[] = [
  "#1c1f21",
  "#272a2c",
  "#312e2c",
  "#35261c",
  "#4b321f",
  "#5c3b24",
  "#6d4c35",
  "#6b503b",
  "#765c45",
  "#7f684e",
  "#99815d",
  "#a79369",
  "#af9c70",
  "#bba063",
  "#d6b97b",
  "#dac38e",
  "#9f7f59",
  "#845039",
  "#682b1f",
  "#61120c",
  "#640f0a",
  "#7c140f",
  "#a02e19",
  "#b64b28",
  "#a2502f",
  "#aa4e2b",
  "#626262",
  "#808080",
  "#aaaaaa",
  "#c5c5c5",
  "#463955",
  "#5a3f6b",
  "#763c76",
  "#ed74e3",
  "#eb4b93",
  "#f299bc",
  "#04959e",
  "#025f86",
  "#023974",
  "#3fa16a",
  "#217c61",
  "#185c55",
  "#b6c034",
  "#70a90b",
  "#439d13",
  "#dcb857",
  "#e5b103",
  "#e69102",
  "#f28831",
  "#fb8057",
  "#e28b58",
  "#d1593c",
  "#ce3120",
  "#ad0903",
  "#880302",
  "#1f1814",
  "#291f19",
  "#2e221b",
  "#37291e",
  "#2e2218",
  "#231b15",
  "#020202",
  "#706c66",
  "#9d7a50",
];
